import React from 'react'

function IconReportConsumerJourney() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100"
      height="100"
      fill="none"
      viewBox="0 0 100 100"
    >
      <rect width="84.181" height="84" x="15.819" fill="#ECF3EE" rx="22.857"></rect>
      <path
        fill="#C5629C"
        d="M27.845 32.732H74.74c1.166 0 2.285.462 3.11 1.285a4.382 4.382 0 011.287 3.102v13.162c0 1.163-.463 2.279-1.288 3.102a4.402 4.402 0 01-3.109 1.285h-4.396v-.95a1.956 1.956 0 00-1.11-1.777 1.966 1.966 0 00-2.085.24l-4.85 3.861a1.986 1.986 0 00-.551 2.41c.129.269.317.505.55.69l4.851 3.861a1.964 1.964 0 003.195-1.535v-.95h5.862a8.83 8.83 0 006.21-2.578A8.79 8.79 0 0085 51.743V35.657a8.79 8.79 0 00-2.583-6.197 8.83 8.83 0 00-6.21-2.577H27.845v5.85zM10.259 60.517a4.401 4.401 0 00-3.11 1.285 4.382 4.382 0 00-1.287 3.102v13.162c0 1.163.463 2.28 1.288 3.102a4.402 4.402 0 003.109 1.285h4.396v-.95a1.956 1.956 0 011.111-1.777 1.966 1.966 0 012.084.24l4.85 3.862a1.983 1.983 0 01.553 2.41c-.13.268-.319.504-.552.69l-4.85 3.86a1.965 1.965 0 01-3.196-1.535v-.95H8.793a8.829 8.829 0 01-6.21-2.578A8.79 8.79 0 010 79.528V63.442a8.791 8.791 0 012.583-6.197 8.83 8.83 0 016.21-2.577h11.724a2.936 2.936 0 012.708 1.805 2.92 2.92 0 01-.635 3.188 2.934 2.934 0 01-2.073.856H10.26zM29.31 85.377a2.934 2.934 0 012.931-2.925h14.656v-.95a1.955 1.955 0 011.11-1.776 1.966 1.966 0 012.085.24l4.85 3.861a1.982 1.982 0 01.553 2.41c-.13.27-.319.505-.552.69l-4.851 3.861a1.964 1.964 0 01-3.195-1.535v-.95H32.242a2.934 2.934 0 01-2.073-.858 2.921 2.921 0 01-.858-2.068zM55.69 57.593c0-.776-.309-1.52-.858-2.068a2.934 2.934 0 00-2.073-.856H38.104v-.951a1.956 1.956 0 00-1.111-1.776 1.966 1.966 0 00-2.084.24l-4.85 3.861a1.985 1.985 0 00-.552 2.41c.13.269.318.504.551.69l4.85 3.861a1.965 1.965 0 003.196-1.535v-.951h14.655c.777 0 1.523-.308 2.073-.857.55-.548.858-1.292.858-2.068z"
      ></path>
      <path
        fill="#A40965"
        d="M14.655 44.43c8.094 0 14.655-6.546 14.655-14.623 0-8.076-6.56-14.623-14.655-14.623C6.561 15.184 0 21.73 0 29.807c0 8.077 6.561 14.624 14.655 14.624z"
      ></path>
      <path
        fill="#F6EFF3"
        d="M14.655 35.657c4.047 0 7.328-3.274 7.328-7.312s-3.28-7.312-7.328-7.312c-4.046 0-7.327 3.274-7.327 7.312s3.28 7.312 7.327 7.312z"
      ></path>
      <path
        fill="#96CA8D"
        d="M70.345 100.001c8.094 0 14.655-6.547 14.655-14.624 0-8.076-6.561-14.623-14.655-14.623S55.69 77.3 55.69 85.377c0 8.077 6.561 14.624 14.655 14.624z"
      ></path>
      <path
        fill="#F6EFF3"
        d="M23.448 41.493v.015a14.676 14.676 0 01-17.586 0v-.015a5.843 5.843 0 011.722-4.127 5.869 5.869 0 014.14-1.708h5.862c1.552 0 3.041.614 4.14 1.708a5.843 5.843 0 011.722 4.127z"
      ></path>
      <path
        fill="#427C37"
        d="M67.414 91.227c-.388 0-.761-.154-1.036-.429l-2.931-2.924a1.461 1.461 0 011.041-2.479c.385-.003.755.145 1.031.41l1.895 1.892 7.757-7.74a1.467 1.467 0 012.484 1.039c.003.383-.145.752-.412 1.028l-8.793 8.774a1.467 1.467 0 01-1.036.429z"
      ></path>
    </svg>
  )
}

export default IconReportConsumerJourney
